namespace $.$$ {
	export class $exso_sheets_login extends $.$exso_sheets_login {
		@$mol_mem
		name_bid(): string {
			if (!this.dirty()) return super.name_bid()
			return !this.name() ? this.required() : super.name_bid()
		}
		@$mol_mem
		pass_bid(): string {
			if (!this.dirty()) return super.pass_bid()
			return !this.pass() ? this.required() : super.pass_bid()
		}
		@$mol_action
		async event_submit() {
			this.dirty(true)
			const name = this.name()
			const pass = this.pass()
			if (!name || !pass) return
			try {
				await this.login?.({ username: name, password: pass })
			} catch (e) {
				if ((e as { error: string }).error === 'Unauthorized')
					throw new Error(this.errors().invalid_credentials, { cause: e })
				throw e
			}
		}
	}
}
